<template>
  <div class="layout-scaffold">
    <div class="layout-body" :class="{ 'pad-bottom': $route.meta.withTabbar }">
      <router-view />
    </div>
    <van-tabbar
      class="layout-tabbar"
      route
      @change="onChange"
      v-if="$route.meta.withTabbar"
    >
      <van-tabbar-item
        v-for="(item, index) in menus"
        :key="index"
        :to="item.path"
        :replace="true"
      >
        <template #default="props">
          <div
            class="tabbar-item c:col-center"
            :class="{ active: props.active }"
          >
            <img
              class="tabbar-item-icon"
              :src="props.active ? item.icon.active : item.icon.inactive"
              alt=""
            />
            <span class="tabbar-item-name">{{ item.name }}</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onChange(index) {
      // console.log("Tab changed", index);
      this.$emit("change", index);
    },
  },
};
</script>
<style lang="less"></style>
<style lang="less" scoped>
.layout-scaffold {
  width: 100%;
  height: 100%;

  .layout-body {
    width: 100%;
    height: 100%;

    overflow-y: auto;

    // &.pad-bottom {
    //   padding-bottom: calc(3.1rem + env(safe-area-inset-bottom));
    // }
  }
}

.layout-tabbar {
  box-sizing: border-box;
  width: 100vw;
  height: calc(3.1rem + constant(safe-area-inset-bottom));
  height: calc(3.1rem + env(safe-area-inset-bottom));
  padding: 11/20rem;
  padding-bottom: calc(0.55rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(0.55rem + env(safe-area-inset-bottom));
  background-color: #fff;
  z-index: 888;
}

.tabbar-item {
  flex: 1;

  line-height: 20/40rem;
  font-size: 20/40rem;

  &-icon {
    font-weight: 400;
    width: 48/40rem;
    height: 48/40rem;
  }
  &-name {
    margin-top: 11/40rem;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
